import React, { useEffect, useState } from "react";

import { Container, Row, Col, Alert } from "react-bootstrap";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

//Components
import TopMargin from "../components/TopMargin";
import RowMargin from "../components/RowMargin";
import { fetchSecure } from "../utils/utils";

const classes = {
  root: {
    flexGrow: 1,
  },
  paper: {
    width: "20%",
    padding: 20,
    margin: 10,
    textAlign: "center",
  },
  button: {
    width: "50px",
    padding: 20,
    margin: 20,
    textAlign: "center",
  },
  font: {
    "font-size": "24px",
  },
};

const divStyle2 = {
  width: "100%",
};

const headerStyle = {
  "font-size": "24px",
};

const rowStyle = {
  padding: "20px 40px",
};

const cardStyle = {
  "background-color": "#e5f1ff",
  "border-radius": "20px",
};

const flex50 = {
  flex: "50%",
  "max-width": "49%",
  "margin-bottom": "20px",
};

export default function User(props) {
  console.log("Begin User");
  const [data, setData] = useState([]);
  const [dataState, setDataState] = useState("IDLE");
  const [imageData /* setImageData */] = useState(
    "data:image/png;base64, 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"
  );
  const [imageWidth /* setImageWidth */] = useState("120");
  const [showSpinner, setShowSpinner] = useState(false);

  useEffect(() => {
    console.log("api/getObject/users/" + props.user);
    fetchSecure("/api/getObject/users/" + props.user)
      .then((response) => response.json())
      .then((data) => {
        var items = [];
        items.push(data);
        setData(items);
        setDataState("SUCCESS");
      })
      .catch(function (error) {
        console.log(error);
      });

    setShowSpinner(true);

    return function cleanup() {
      console.log("Doing Cleanup");
    };
  }, [props.user]);

  return (
    <Container fluid className={classes.paper}>
      <Row>
        <Col style={divStyle2}>
          <TopMargin />
          <h1>User Details for {props.user}</h1>
        </Col>
      </Row>
      <RowMargin />
      {data && dataState === "SUCCESS" && data.length === 0 && (
        <React.Fragment>
          <RowMargin />
          <Row>
            <Col>
              <Alert variant='danger'>No matches found.</Alert>
            </Col>
          </Row>
        </React.Fragment>
      )}
      {data &&
        data.length > 0 &&
        data.map((item) => {
          var url = "https://xxx/search?q=" + item.User;
          return (
            <Grid className={classes.paper} style={flex50} spacing={2}>
              <Grid item xs={12}>
                <Paper
                  className={classes.paper}
                  style={cardStyle}
                  elevation={8}>
                  <Row style={rowStyle}>
                    <Col xs>
                      <Row>
                        <Col>
                          <Typography gutterBottom variant='subtitle1'>
                            <b>
                              <font style={headerStyle} color='red'>
                                <a href={url} target='_blank' rel='noreferrer'>
                                  {item.User}
                                </a>
                              </font>
                            </b>
                          </Typography>
                        </Col>
                        {!showSpinner && (
                          <Col>
                            <img
                              alt={imageData}
                              src={imageData}
                              width={imageWidth}
                              px
                            />
                          </Col>
                        )}
                      </Row>
                      <Typography variant='body2' gutterBottom>
                        <font color='#004999'>
                          <b>Item 1</b>{" "}
                          {item.Interests && item.Interests.join(", ")}
                        </font>
                      </Typography>
                    </Col>
                  </Row>
                </Paper>
              </Grid>
            </Grid>
          );
        })}
    </Container>
  );
}
/*
                <Typography variant="body2" gutterBottom>
                      <font color="blue"><b>Business Interests:</b> {item.BusinessInterests.join(", ")}</font>
                </Typography>
          <Row>
                <Col> 
                  <div
                     style={
                     {
                        background: '#00FFFF',
                        fontSize: "24px",
                        marginBottom: "10px"
                     }
                     }
                  >
                      {item.User}, Interests: {item.Interests}, High School: {item.HighSchool}, College: {item.College}
                  </div>
                </Col>
           </Row>
<UploadFile fileName={props.user.concat(".png")}/> to put their picture
*/
